import { MACRO_MEDIA_BASE } from './media';

export const WALLETS_OPTIONS = [
  { value: 'apple-pay', label: 'Apple Pay', imageUrl: `${MACRO_MEDIA_BASE}/wallets/apple-pay.png?v=2` },
  { value: 'google-pay', label: 'Google Pay', imageUrl: `${MACRO_MEDIA_BASE}/wallets/google-pay.png` },
  { value: 'google-pay-white', label: 'Google Pay', imageUrl: `${MACRO_MEDIA_BASE}/wallets/google-pay-white.png?v=5` },
  { value: 'modo-NFC-white', label: 'Modo', imageUrl: `${MACRO_MEDIA_BASE}/wallets/modo-NFC-white.png` },
  { value: 'modo-NFC-green', label: 'Modo', imageUrl: `${MACRO_MEDIA_BASE}/wallets/modo-NFC-green.png` }
];
